import { RouteInfo } from "./sidebar.metadata";

export const ROUTES: RouteInfo[] = [
  {
    path: "",
    title: "Général",
    icon: "mdi mdi-dots-horizontal",
    class: "nav-small-cap",
    extralink: true,
    submenu: []
  },
  {
    path: "/accueil",
    title: "Tableau de bord",
    icon: "mdi mdi-view-dashboard",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/general/utilisateurs",
    title: "Utilisateurs",
    icon: "mdi mdi-account-multiple",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/general/abonnements",
    title: "Abonnements",
    icon: "mdi mdi-bell",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/general/matieres",
    title: "Matières",
    icon: "mdi mdi-format-list-bulleted",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/general/classes",
    title: "Classes",
    icon: "mdi mdi-clipboard-account",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "",
    title: "Contenu",
    icon: "mdi mdi-dots-horizontal",
    class: "nav-small-cap",
    extralink: true,
    submenu: []
  },
  {
    path: "/contenu/cours",
    title: "Cours",
    icon: "mdi mdi-book-open-page-variant",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/contenu/quiz",
    title: "Quiz",
    icon: "mdi mdi-timer",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/contenu/interros",
    title: "Interro-DS",
    icon: "mdi mdi-calendar-question",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/contenu/annales",
    title: "Annales",
    icon: "mdi mdi-file-document-box",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/contenu/blog",
    title: "Blog",
    icon: "mdi mdi-message-text",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/contenu/forums",
    title: "Forums",
    icon: "mdi mdi-forum",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/notifications",
    title: "Notifications",
    icon: "mdi mdi-bell",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "",
    title: "Infos Légales",
    icon: "mdi mdi-dots-horizontal",
    class: "nav-small-cap",
    extralink: true,
    submenu: []
  },
  {
    path: "/legal/conditions",
    title: "Conditions générales",
    icon: "mdi mdi-lock",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/legal/politiques",
    title: "Politiques",
    icon: "mdi mdi-information",
    class: "",
    extralink: false,
    submenu: []
  },
  {
    path: "/legal/mentions",
    title: "Mentions légales",
    icon: "mdi mdi-scale-balance",
    class: "",
    extralink: false,
    submenu: []
  }
];
